import React, { useCallback, useEffect, useState } from 'react'
import { IoIosAddCircleOutline } from 'react-icons/io';
import AddRefillOrder from './AddRefillOrder';
import RefillList from './RefillList';
import { refillListApi } from 'services/user';

const RefillSchedule = ({ userId }) => {
  const [addFormOpen, setAppFormOpen] = useState(false)
  const [editOrder, setEditOrder] = useState(null)
  const [editMode, setEditMode] = useState('order')
  const [refill, setRefill] = useState([])
  // ----------Listing-API-------------------
  const refillList = useCallback(async () => {
    try {
      const res = await refillListApi(userId);
      const { code, data } = res?.data;
      if (code === 200) {
        // setTotal(data?.total || 0)
        setRefill(data || []);
      }
    } catch (error) {
      console.log(error);
    }
  }, [userId])
  useEffect(() => {
    refillList()
  }, [refillList])

  const handleAddFormOpen = () => {
    setEditOrder(null);
    setEditMode('order');
    setAppFormOpen(true);
  };

  const handleEditOrder = (order) => {
    setEditOrder(order);
    setEditMode('order');
    setAppFormOpen(true);
  };

  const handleEditMedicine = (order) => {
    setEditOrder(order);
    setEditMode('medicine');
    setAppFormOpen(true);
  };

  const handleCloseForm = () => {
    setEditOrder(null);
    setEditMode('order');
    setAppFormOpen(false);
  };

  return (
    <div className="add-cat-parent-container">
      {!addFormOpen &&
        <div className="tabs-container d-flex justify-content-center mt-4">
          <div className="tabs-box d-flex">
            <div
              className='tab-item'
              onClick={handleAddFormOpen}
            >
              <IoIosAddCircleOutline className='fs-2 mx-3' />  Add a new refill order
            </div>
          </div>
        </div>}
      <div className="card">
        {/* -------------form------------------ */}
        {addFormOpen && (
          <AddRefillOrder
            {...{ userId, refillList }}
            setAppFormOpen={setAppFormOpen}
            editOrder={editOrder}
            onCancelEdit={handleCloseForm}
            editMode={editMode}
          />
        )}
        {/* -------------listing------------------ */}

        {!addFormOpen && (
          <RefillList
            {...{ refill, refillList, userId }}
            onEditOrder={handleEditOrder}
            onEditMedicine={handleEditMedicine}
          />
        )}

      </div>
    </div>
  )
}

export default RefillSchedule
